import { createFileRoute } from '@tanstack/react-router';
import { requirePermission } from '@/features/admin/guard';
import { RoleList } from '@/features/admin/roles/role-list';

export const Route = createFileRoute('/_app/admin/roles/')({
  beforeLoad: ({ context }) => {
    requirePermission(context.me, 'admin.roles');
  },
  component: RoleList,
});
